import React from "react";
import {
  TransactionMassage,
  WalletModalStyles,
  ModalWrapper,
  ImgContainer,
  InfoContainer,
  Button,
  ButtonContainer,
} from "./GiftModal.styled";
import successImg from "assets/images/Done.png";
export default function GiftModal({ pay, giftCode, amount, giftId }) {
  return (
    <WalletModalStyles>
      <ModalWrapper>
        <ImgContainer>
          <img src={successImg} alt="factor" />
        </ImgContainer>
        <TransactionMassage>
          <h2>افزایش اعتبار با موفقیت انجام شد.</h2>
        </TransactionMassage>
        <InfoContainer>
          <div>
            <div>مبلغ اعتبار:</div>
            <div>{amount}</div>
          </div>
          <div>
            <div>کد هدیه:</div>
            <div>{giftCode}</div>
          </div>
          <div>
            <div>کد پیگیری:</div>
            <div>{giftId}</div>
          </div>
        </InfoContainer>
        <ButtonContainer>
          <Button onClick={pay}>تایید</Button>
          {/* <Button onClick={closing}>بازگشت</Button> */}
        </ButtonContainer>
      </ModalWrapper>
    </WalletModalStyles>
  );
}
